var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnsibleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1918",
    d: "M255.879 127.868c0 70.455-57.11 127.565-127.566 127.565-70.45 0-127.566-57.11-127.566-127.565C.747 57.418 57.863.302 128.313.302c70.456 0 127.566 57.116 127.566 127.566"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m130.46 78.229 33.012 81.476-49.864-39.278zm58.645 100.245-50.78-122.202c-1.449-3.524-4.347-5.39-7.865-5.39-3.524 0-6.634 1.866-8.083 5.39l-55.733 134.04h19.065l22.062-55.265 65.84 53.19c2.647 2.14 4.558 3.109 7.041 3.109 4.974 0 9.322-3.729 9.322-9.111 0-.876-.31-2.266-.87-3.761z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsibleLogo);
export default __webpack_public_path__ + "static/media/ansible-logo.7bc9b2a27e086f472ec9bfc130527d8c.svg";
export { ForwardRef as ReactComponent };